import {
    GetNotesForPersonaRequest,
    GetPersonaNotesResponse,
    PersonaType,
    getServiceAsync,
} from '../../../../service';
import { runOwsRequestWithMonitor, Feature } from '../../..';

export function getNotesForPersona(
    personaId: string,
    contactFolderId: string,
    additionalLogProperties?: {}
): Promise<PersonaType> {
    return getServiceAsync().then(service => {
        let request: GetNotesForPersonaRequest = service.Factory.getNotesForPersonaRequest({
            PersonaId: personaId,
            MaxBytesToFetch: 512000, // Same as JsMMVM people hub
        });

        // Parent folder is needed for Public Folders
        if (!!contactFolderId) {
            request.ParentFolderId = service.Factory.targetFolderId({
                BaseFolderId: service.Factory.folderId({ Id: contactFolderId }),
            });
        }

        return runOwsRequestWithMonitor({
            scenarioName: 'GetPersonaNotes',
            feature: Feature.ContactManagement,
            operation: () =>
                service.Operation.getNotesForPersonaOperation({
                    getNotesForPersonaRequest: request,
                }),
            qoSConfig: additionalLogProperties && {
                additionalQoSLogProperty: additionalLogProperties,
            },
            transformResponse: (response: GetPersonaNotesResponse) => response.PersonaWithNotes,
        });
    });
}
